import { Component, EventEmitter, Output } from '@angular/core';
import { AiAssistantService } from '../../services/ai-assistant.service';

@Component({
    selector: 'atlas-ai-chat-history',
    templateUrl: './ai-chat-history.component.html',
    styleUrl: './ai-chat-history.component.less',
    standalone: false
})
export class AiChatHistoryComponent {
  @Output() changeTab = new EventEmitter<number>();

  constructor() {}

  onChangeTab($event: number) {
    this.changeTab.emit($event);
  }
}
